<div class="row demonstration">
  <div class="col-md-12">
    <div class="panel">
      <div class="panel-heading">
        <span class="label pull-right"> DEMONSTRATION </span>
        <button class="btn btn-default" (click)="closeClicked.emit()">
          Close Audit Detail
          <span aria-hidden="true" class="closeButton">&times;</span>
        </button>
      </div>

      <div class="panel-body">
        <h3>Processing Notes</h3>
        <app-grid-wrapper #gridProcessingNotes [gridSize]="GridSize.small" [autoHeight]="false">
          <button class="btn btn-default" (click)="addEntry()">Add Entry</button>
        </app-grid-wrapper>
        <h3>Audit Info</h3>
        <app-grid-wrapper #gridAuditInfo [gridSize]="GridSize.small" [autoHeight]="false">
        </app-grid-wrapper>
      </div>
    </div>
  </div>
</div>
